(function ($) {
  // Speichert die Höhe des Headers im initialen, voll ausgefahrenen Zustand.
  let TOTAL_HEADER_HEIGHT = 0;

  // Sobald das DOM bereit ist, wird die Höhe des Headers im initialen, ausgefahrenen Zustand gemessen.
  $(function () {
    TOTAL_HEADER_HEIGHT = $('#header').outerHeight() || 0;
  });

  /**
   * Überprüft, ob ein String ein gültiger CSS-Selektor ist.
   * @param {string} selector Der zu überprüfende Selektor.
   * @returns {boolean} Gibt true zurück, wenn der Selektor gültig ist, andernfalls false.
   */
  function isValidSelector(selector) {
    if (typeof selector !== 'string' || selector.trim().length === 0) {
      return false;
    }
    try {
      document.querySelector(selector);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Setzt den Fokus auf ein Zielelement, um die Barrierefreiheit zu gewährleisten,
   * ohne dass der Browser dorthin scrollt.
   * Macht das Element bei Bedarf fokussierbar und entfernt diese Eigenschaft wieder,
   * wenn der Fokus verloren geht.
   * @param {jQuery} $target Das jQuery-Objekt des Zielelements.
   */
  function setFocusOnTarget($target) {
    if (!$target || !$target.length) {
      return;
    }
    const wasOriginallyFocusable = $target.attr('tabindex') !== undefined;
    if (!wasOriginallyFocusable) {
      $target.attr('tabindex', -1);
      $target.one('blur.smoothscroll', function () {
        $(this).removeAttr('tabindex');
      });
    }
    // Das native focus() mit preventScroll verwenden, um unser eigenes Scroll-Verhalten nicht zu überschreiben.
    $target[0].focus({preventScroll: true});
  }

  /**
   * Berechnet die angepasste Scroll-Position unter Berücksichtigung der Header-Höhe und der Scroll-Richtung.
   * Beim Laden der Seite (isAnchorClick = false) wird immer die volle Höhe des ausgefahrenen Headers abgezogen,
   * um sicherzustellen, dass der Inhalt nicht vom Header verdeckt wird.
   * Beim Klick auf einen Anker-Link (isAnchorClick = true) wird die Scroll-Richtung berücksichtigt:
   * - Beim Scrollen nach oben wird die volle Höhe des ausgefahrenen Headers abgezogen, da dieser sichtbar ist.
   * - Beim Scrollen nach unten wird nur die Höhe der zweiten Navigationsebene abgezogen, da der Header kompakt ist und diese Ebene das Ziel verdecken könnte.
   *
   * @param {number} scrollTop Die ursprüngliche vertikale Position, zu der gescrollt werden soll.
   * @param {boolean} [isAnchorClick=true] Gibt an, ob die Anpassung für einen Anker-Click erfolgt (true) oder für das Laden der Seite (false).
   * @returns {number} Die angepasste Scroll-Position.
   */
  function adjustScrollPosition(scrollTop, isAnchorClick = true) {
    if (typeof scrollTop !== 'number') {
      return;
    }

    if(!isAnchorClick) {
      // 16px Abstand zum Header hinzufügen, um sicherzustellen, dass der Inhalt nicht direkt am Header klebt.
      return scrollTop - TOTAL_HEADER_HEIGHT - 16;
    }

    //Beim Klick auf einen Anker-Link muss die Scroll-Richtung berücksichtigt werden.
    if (window.scrollY > scrollTop) {
      // SCROLLEN NACH OBEN: Die vorgemessene Höhe des ausgefahrenen Headers verwenden.
      scrollTop -= TOTAL_HEADER_HEIGHT;
    } else {
      // SCROLLEN NACH UNTEN: Der Header ist kompakt. Die Höhe der zweiten Navigationsebene verwenden,
      // da diese das Ziel verdecken könnte.
      const secondLevelHeight = $('#header-navi-second-level').outerHeight() || 0;
      scrollTop -= secondLevelHeight;
    }

    return scrollTop;
  }

  /**
   * Korrigiert die Scroll-Position beim Laden der Seite, nachdem alle Ressourcen geladen wurden.
   * Dies geschieht im 'load'-Event, um Race-Conditions mit dem nativen Sprung des Browsers zu vermeiden.
   */
  $(window).on('load', function () {
    const hash = window.location.hash;
    if (hash && !hash.includes('=') && isValidSelector(hash)) {
      try {
        const $target = $(hash);
        if ($target.length) {
          const top = adjustScrollPosition($target.offset().top, false);

          windowScrollTo(top, 'auto');

          // Fokus für Barrierefreiheit setzen.
          setFocusOnTarget($target);
        }
      } catch (e) {
        console.error('Fehler beim Scrollen zum Hash nach dem Laden der Seite:', e);
      }
    }
  });

  /**
   * Fängt Klicks auf Anker-Links ab, um ein sanftes Scrollen zum Ziel zu ermöglichen,
   * anstatt das Standard-Sprungverhalten des Browsers zu verwenden. Es wird überprüft,
   * ob der Ziel-Hash ein gültiger CSS-Selektor ist, bevor versucht wird, zum Ziel zu scrollen.
   * Der Fokus wird auf das Ziel gesetzt, um die Barrierefreiheit zu gewährleisten, ohne
   * dass der Browser automatisch dorthin scrollt. Der Hash in der URL wird aktualisiert,
   * ohne die Seite neu zu laden, um permanente Links zu ermöglichen.
   */
  $(document).on('click', 'a[href^="#"]', function (event) {
    const targetId = $(this).attr('href');

    if (!isValidSelector(targetId)) {
      return;
    }

    try {
      const $targetElement = $(targetId);

      if ($targetElement.length) {
        // Standard-Sprungverhalten des Browsers verhindern.
        event.preventDefault();

        let scrollTop = adjustScrollPosition($targetElement.offset().top);

        windowScrollTo(scrollTop);

        // Den Hash in der URL für permanente Links aktualisieren.
        history.replaceState(null, null, targetId);

        // Den Fokus sofort setzen, aber ohne zu scrollen.
        setFocusOnTarget($targetElement);
      }
    } catch (e) {
      console.error('Fehler beim Scrollen zum Anker:', e);
    }
  });

  /**
   * Sorgt dafür, dass das Fenster zur angegebenen vertikalen Position scrollt, und berücksichtigt dabei die Höhe des Headers.
   * Setzt den Fokus auf ein optionales Zielelement, um die Barrierefreiheit zu gewährleisten.
   * @param {number} top Die vertikale Position, zu der gescrollt werden soll.
   * @param {jQuery} [$scrollTarget] Optionales jQuery-Objekt des Zielelements, auf das der Fokus gesetzt werden soll.
   */
  function scrollTo(top, $scrollTarget) {
    if (typeof top !== 'number' || Number.isNaN(top)) {
      return;
    }

    // Die Scroll-Position anpassen, um die Höhe des Headers zu berücksichtigen.
    top = adjustScrollPosition(top, false);

    windowScrollTo(top);
    setFocusOnTarget($scrollTarget);
  }

  /**
   * Scrollt das Fenster zur angegebenen Position mit einem sanften Scroll-Verhalten, es sei denn,
   * die 'prefers-reduced-motion'-Einstellung des Nutzers legt etwas anderes nahe.
   *
   * @param {number} scrollTop Die vertikale Position, zu der gescrollt werden soll.
   * @param {string} [scrollBehavior] Optionales Scroll-Verhalten ('smooth' oder 'auto').
   */
  function windowScrollTo(scrollTop, scrollBehavior = '') {
    let useScrollBehavior;

    if(scrollBehavior !== '') {
      // Ein explizites Scroll-Verhalten wurde übergeben, dieses verwenden.
      useScrollBehavior = scrollBehavior;
    } else {
      // Die 'prefers-reduced-motion'-Einstellung des Nutzers für Barrierefreiheit berücksichtigen.
      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      useScrollBehavior = motionQuery.matches ? 'auto' : 'smooth';
    }

    window.scrollTo({
      // Eine negative Scrollposition soll vermieden werden.
      top: scrollTop < 0 ? 0 : scrollTop,
      behavior: useScrollBehavior
    });
  }

  /**
   * Utils
   */
  SWRNEU.ScrollSmoothHelper = {
    scrollTo: scrollTo
  };
}(window.jQuery));
